const phoneUtil = require("google-libphonenumber").PhoneNumberUtil.getInstance();
//const isEmail = require('sane-email-validation');

const validate = (values, props) => {
  const errors = {};

  if (!values.firstName || !/^[a-zA-Z ]*$/g.test(values.firstName)) {
    errors.firstName = "Please enter your first name (text only)";
  }

  if (!values.lastName || !/^[a-zA-Z ]*$/g.test(values.lastName)) {
    errors.lastName = "Please enter your last name (text only)";
  }

  if (!values.email) {
    errors.email = "Required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Please enter a valid email address";
  }

  try {
    const number = phoneUtil.parse(values.phone);

    if (
      !phoneUtil.isPossibleNumber(number) ||
      !phoneUtil.isValidNumber(number)
    ) {
      errors.phone =
        "Please enter a valid phone number including country code e.g. +447900123456";
    }
  } catch (error) {
    if (error && error.message) {
      errors.phone = error.message.replace(/string/gi, "number");
    }
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/containers/QuotePage/TravelDetailsPanel/form/validate.js